import '@static/index.css';
import '@design/design-tokens/_radix-colors.scss';
import '@design/design-tokens/themes/themes.scss';
import '@design/components/custom-scroll/custom-scroll-global.scss';
import '@terminal/utils/i18n/i18n';

import { FloatingDelayGroup } from '@floating-ui/react';
import { getApplicationContainer } from '@helpers';
import { app } from '@microsoft/teams-js';
import { QueryClientProvider } from '@tanstack/react-query';
import { Routes } from '@teams/routes';
import { queryClient } from '@terminal/services/query-client/queryClient';
import { Tracking } from '@terminal/services/tracking';
import { PostHogProvider } from '@terminal/services/tracking/posthog/PostHogProvider';
import { createRoot } from 'react-dom/client';

// Teams has its own router under /app and does not use
// withFaroRouterInstrumentation, so skip the ReactIntegration that would
// otherwise patch matchRoutes globally and break route validation.
Tracking.initialise({ reactRouterIntegration: false });

const renderApp = () => {
  const root = createRoot(getApplicationContainer());

  root.render(
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <FloatingDelayGroup delay={{ open: 300, close: 0 }} timeoutMs={300}>
          <Routes />
        </FloatingDelayGroup>
      </QueryClientProvider>
    </PostHogProvider>
  );
};

// app.initialize() only resolves inside the Teams client.
// Outside Teams (direct browser, dev mode) it rejects — render anyway.
//
// app.notifySuccess() tells the Teams host the content page has loaded and is
// ready for interaction. It must fire here — right after init, decoupled from
// auth — because Teams clears its native loading indicator on this signal and
// otherwise aborts the tab with "failed reason: AppInitTimeout" after ~20-30s,
// which is exactly the window a user spends on the sign-in popup.
app
  .initialize()
  .then(() => app.notifySuccess())
  .catch(() => {})
  .finally(renderApp);
